<div>
  <ng-select
    [clearable]="isClearable"
    [clearOnBackspace]="false"
    #country
    [items]="conversionRegion"
    bindLabel="name"
    [searchable]="false"
    [searchFn]="commonInputSearchForCountry"
    placeholder="Select country"
    [(ngModel)]="countryId"
    bindValue="id"
    (change)="updateValue(countryId)"
  >
    <div *ngIf="conversionRegion.length > 5">
      <ng-template ng-header-tmp>
        <div class="has-feedback">
          <input
            type="text"
            (input)="country.filter($any($event.target).value)"
            class="accordion-search form-control search-input"
            id="inputValidation"
            placeholder="Search..."
          />
          <span class="form-control-feedback">
            <i class="fa fa-search icon"></i>
          </span>
        </div>
      </ng-template>
    </div>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
    </ng-template>
  </ng-select>
</div>
